// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3V0BM","head":"Table_head__1VmKj","col":"Table_col__3GY1H"};